<template>
  <div class="act-sayhi-root">
    <div v-if="env.isApp" class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>
    <div v-else style="width: 100%; height: 40px"></div>

    <div class="sayhi-content">
      <!-- Upload Video to Earn 1000 -->
      <MyPLabel class="sayhi-head" :str="$t('lang.SayHi.k001')" :customClass="{ bean: 'sayhi-head-beans' }" />

      <p v-if="since && until" class="sayhi-date">{{ handleMoment(since, 'DD/MM/YYYY') }} - {{ handleMoment(until, 'DD/MM/YYYY') }}</p>

      <div class="sayhi-bg" @click="handleClaim">
        <img class="sayhi-bg-icon1" :src="getMatchImg('beans')" />
        <img class="sayhi-bg-icon2" :src="getMatchImg('beans')" />
        <template v-if="actStatus === 'CLAIMED'">
          <img class="sayhi-bg-main" src="./images/gift-box-open.webp" />
          <img class="sayhi-bg-tips" src="./images/tips-arrow.webp" />
          <div class="sayhi-claimed">{{ $t('lang.CommonModule.k004') }}</div>
        </template>
        <template v-else>
          <img class="sayhi-bg-main" :class="{ 'can-claim': actStatus === 'APPROVED' }" src="./images/gift-box-close.webp" />
        </template>
      </div>

      <!-- Upload greeting video which will be recommended to users to get their calls. -->
      <p class="sayhi-tips">{{ $t('lang.SayHi.k002') }}</p>

      <van-uploader
        ref="vanUploader"
        style="position: fixed; top: 100px; left: 0; z-index: -1"
        :accept="'video/mp4,video/ogg,video/webm'"
        :after-read="afterRead"
      />

      <!-- 视频未上传 -->
      <div v-if="actStatus === 'NONE'" class="sayhi-upload no-video-block">
        <div class="upload-btns">
          <button class="upload-yellow" @click="chooseFile">
            <img src="./images/upload-icon.webp" />
            {{ $t('lang.SayHi.k008') }}
          </button>
        </div>

        <div class="upload-tips-txt">
          1.
          <span>{{ $t('lang.SayHi.k003') }}</span>
        </div>
        <div class="upload-tips-txt">
          2.
          <span>{{ $t('lang.SayHi.k004') }}</span>
        </div>
        <div class="upload-tips-txt">
          3.
          <span>{{ $t('lang.SayHi.k005') }}</span>
        </div>
      </div>

      <!-- 视频被拒绝 -->
      <div v-if="actStatus === 'REJECTED'" class="sayhi-upload no-video-block">
        <p class="reject-txt">{{ $t('lang.SayHi.k011') }}</p>
        <div class="upload-btns">
          <button class="upload-yellow" @click="chooseFile">
            <img src="./images/upload-icon.webp" />
            {{ $t('lang.SayHi.k009') }}
          </button>
        </div>
        <div class="upload-tips-txt">
          1.
          <span>{{ $t('lang.SayHi.k003') }}</span>
        </div>
        <div class="upload-tips-txt">
          2.
          <span>{{ $t('lang.SayHi.k004') }}</span>
        </div>
        <div class="upload-tips-txt">
          3.
          <span>{{ $t('lang.SayHi.k005') }}</span>
        </div>
      </div>

      <!-- 视频审核中 -->
      <div v-if="actStatus === 'PENDING'" class="sayhi-upload">
        <div class="upload-video" @click="handleShowVideo(uploadedVideoUrl)">
          <img :src="thumbnail" />
        </div>
        <div class="upload-btns">
          <p>{{ $t('lang.SayHi.k010') }}</p>
          <button class="upload-yellow" @click="chooseFile">
            <img src="./images/upload-icon.webp" />
            {{ $t('lang.SayHi.k009') }}
          </button>
        </div>
      </div>

      <!-- 待领取奖励 -->
      <div v-if="actStatus === 'APPROVED'" class="sayhi-upload">
        <div class="upload-video" @click="handleShowVideo(uploadedVideoUrl)">
          <img :src="thumbnail" />
        </div>
        <div class="upload-btns">
          <p>{{ $t('lang.SayHi.k012') }}</p>
          <button class="upload-yellow" @click="handleClaim">{{ $t('lang.CommonModule.k003') }}</button>
        </div>
      </div>

      <!-- 已领取奖励 -->
      <div v-if="actStatus === 'CLAIMED'" class="sayhi-upload">
        <div class="upload-video" @click="handleShowVideo(uploadedVideoUrl)">
          <img :src="thumbnail" />
        </div>
        <div class="upload-btns">
          <p>{{ $t('lang.SayHi.k012') }}</p>
          <button>{{ $t('lang.CommonModule.k004') }}</button>
        </div>
      </div>

      <div class="videos-title">{{ $t('lang.SayHi.k007') }}</div>
      <div class="videos-block">
        <div v-for="(item, index) in list" :key="index" class="video-item" @click="handleShowVideo(item.url)">
          <img :src="item.thumbnail" />
        </div>
      </div>
      <div v-if="loading" class="is-loading">
        <van-loading size="24px" />
      </div>
      <div v-if="!loading && finished" class="no-more">{{ $t('lang.BeerCollect.k011') }}</div>
    </div>

    <div v-if="isUploading" class="upload-mask">
      <van-circle v-model="percent" :rate="percent" speed="100" size="75" fill="#fafafa" color="#f7a704" stroke-width="80" :text="`${percent}%`" />

      <div class="cancel-upload" @click="cancelUpload">×</div>
    </div>

    <div v-if="showVideo" class="upload-mask" @click="handleClosePlay">
      <div class="will-play">
        <video :src="currentVideo" controls muted autoplay style="width: 100%"></video>
        <div class="cancel-play" @click="handleClosePlay">×</div>
      </div>
    </div>

    <van-popup class="van-popup-box" v-model="showRewardDia" @close="closeShowRewardDia" :lock-scroll="false">
      <div class="reward-dia">
        <img class="bulibuli" :src="getMatchImg('reward-bg')" alt="" @error="onRewardBgError" />
        <span class="number">
          <i>x</i>
          {{ rewardNumber }}
        </span>
      </div>
      <div class="reward-dia-btn">
        <span @click="closeShowRewardDia">{{ $t('lang.CommonModule.k005') }}</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getAwsInfoApi } from '@/api/imee.js'
import { sayHiStatus, claimSayHiReward, submitSayHiVideo, getVideoList } from './apidir/api.js'
import { decryptCode, encryptCode } from '@/utils/common.js'

import SecretKey from '@/config/secret-key.js'
import videoMixin from './mixins/video.mixin.js'
import AWS from 'aws-sdk'

let awsClient = null
let uploadObj = {
  currentFile: null,
  uploadId: null,
  parts: [],
}
const bucketName = 'relationcoachf70d843ba0934dfebf4f63dcdb5f9158102154-dev'

export default {
  components: {},
  props: {},
  mixins: [videoMixin],
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
      // 当前状态
      actStatus: 'NONE',
      uploadedVideoUrl: '',
      since: null,
      until: null,
      thumbnail: null,
      // 上传视频
      isUploading: false,
      chunks: 0,
      percent: 0,
      nativeScroll: null,
      loading: false,
      finished: false,
      // 列表数据
      offset: 0,
      limit: 6,
      list: [],
      // 当前上传的
      videoUrl: '',
      // 待播放视频
      showVideo: false,
      currentVideo: '',
      showRewardDia: false,
      rewardNumber: 0,
    }
  },
  methods: {
    getActStatus() {
      // 活动状态
      sayHiStatus().then((resData) => {
        this.since = resData.since
        this.until = resData.until
        this.actStatus = resData.status
        this.uploadedVideoUrl = resData.videoUrl
        this.thumbnail = resData.thumbnail
        // todo-调试
        // this.actStatus = 'APPROVED'

        // NONE     ——用户未上传过视频
        // REJECTED ——视频审核被拒绝
        // PENDING  ——待审核
        // APPROVED ——审核通过待领奖
        // CLAIMED  ——已领奖
      })
    },
    handleClaim() {
      if (this.actStatus === 'PENDING') {
        this.$client.showToast(this.$t('lang.SayHi.k006'))
        return
      }
      if (this.actStatus === 'NONE' || this.actStatus === 'REJECTED') {
        this.$client.showToast(this.$t('lang.SayHi.k014'))
        return
      }
      if (this.actStatus === 'CLAIMED') {
        this.$client.showToast(this.$t('lang.SayHi.k015'))
        return
      }
      if (this.actStatus === 'APPROVED') {
        claimSayHiReward().then((resData) => {
          if (resData.data === true) {
            this.rewardNumber = resData.beans || 0
            this.showRewardDia = !!this.rewardNumber
            this.getActStatus()
          }
        })
      }
    },
    // 上传参数
    getBeforeUploadInfo() {
      getAwsInfoApi().then((resData) => {
        try {
          const jsonObj = JSON.parse(decryptCode(resData, SecretKey.pk))
          // AWS 认证相关
          awsClient = new AWS.S3({
            accessKeyId: jsonObj.accessKeyId,
            secretAccessKey: jsonObj.secretAccessKey,
            region: jsonObj.region,
          })
        } catch (err) {
          console.log('try catch', err)
        }
      })
    },
    loadVideos() {
      this.loading = true
      getVideoList({ offset: this.offset, limit: this.limit }).then((resData) => {
        resData = resData || []

        this.list = this.list.concat(resData)
        this.offset = this.list.length

        this.loading = false
        this.finished = resData.length < this.limit

        if (!this.finished) {
          this.nativeScroll && this.nativeScroll.finishPullUp()
        }
      })
    },
    // 使用原生input
    handleVideoSelect(event) {
      const file = event.target.files[0]
      if (file) {
        this.afterRead({ file })
      }
    },
    // 文件分片上传主逻辑
    async uploadFileInChunks(file) {
      const that = this
      const chunkSize = 5 * 1024 * 1024
      const chunks = Math.ceil(file.size / chunkSize)

      this.chunks = chunks

      try {
        // 1. 创建分片上传任务
        await that.createMultipartUpload(file)

        that.isUploading = true
        // 2. 逐个上传分片
        for (let i = 0; i < chunks; i++) {
          const start = i * chunkSize
          const end = Math.min(file.size, start + chunkSize)
          const chunk = file.slice(start, end)

          await that.uploadChunk(chunk, i + 1)
        }

        // 3. 完成分片上传
        await that.complete()
      } catch (err) {
        console.log('try catch', err)
      }
    },
    async createMultipartUpload(file) {
      const that = this
      const key = 'public/picture/agent/' + that.getUid() + '_' + file.lastModified + '/' + file.name
      uploadObj.key = key

      const params = {
        Bucket: bucketName,
        Key: uploadObj.key,
      }
      uploadObj.uploadId = await awsClient
        .createMultipartUpload(params)
        .promise()
        .then((data) => data.UploadId)
    },
    async uploadChunk(chunk, partNumber) {
      if (uploadObj.key && uploadObj.uploadId) {
        const params = {
          Bucket: bucketName,
          Key: uploadObj.key,
          UploadId: uploadObj.uploadId,
          PartNumber: partNumber,
          Body: chunk,
        }

        const data = await awsClient.uploadPart(params).promise()
        uploadObj.parts.push({ ETag: data.ETag, PartNumber: partNumber })

        this.percent = Math.floor((uploadObj.parts.length / this.chunks) * 100)
      }
    },
    async complete() {
      const that = this
      const completeParams = {
        Bucket: bucketName,
        Key: uploadObj.key,
        UploadId: uploadObj.uploadId,
        MultipartUpload: { Parts: uploadObj.parts },
      }

      await awsClient.completeMultipartUpload(completeParams).promise()

      this.videoUrl = `https://${bucketName}.s3.amazonaws.com/${uploadObj.key}`

      let thumbPromise = Promise.resolve(null)
      const thumbRes = await this.getVideoThumbnailAsFile(uploadObj.currentFile)
      if (thumbRes.file && awsClient) {
        thumbPromise = new Promise((resolve, reject) => {
          const thumbKey = 'public/picture/agent/' + that.getUid() + '_' + thumbRes.file.lastModified + '/' + thumbRes.file.name
          awsClient.upload(
            {
              Bucket: bucketName,
              Key: thumbKey,
              Body: thumbRes.file,
            },
            function (err, data) {
              if (err) {
                resolve(null)
              }
              // success
              else {
                resolve(`https://${bucketName}.s3.amazonaws.com/${thumbKey}`)
              }
            }
          )
        })
      }

      thumbPromise.then((thumbUrl) => {
        // 上传完成
        this.resetUploadObj()
        this.isUploading = false

        sayHiStatus().then((resData) => {
          this.actStatus = resData.status
          if (resData.expired) {
            this.$client.showToast(resData.message)
            return
          }

          if (['NONE', 'REJECTED', 'PENDING'].includes(this.actStatus)) {
            // 保存视频链接
            submitSayHiVideo(this.videoUrl, thumbUrl).then((resData) => {
              this.getActStatus()
            })
          }
        })
      })
    },
    async cancelUpload() {
      const abortParams = {
        Bucket: bucketName,
        Key: uploadObj.key,
        UploadId: uploadObj.uploadId,
      }

      await awsClient.abortMultipartUpload(abortParams).promise()

      // 取消上传
      this.resetUploadObj()
    },
    resetUploadObj() {
      uploadObj = {
        currentFile: null,
        uploadId: null,
        parts: [],
      }
      this.isUploading = false
      this.percent = 0
    },
    chooseFile() {
      // 先判断活动是否结束
      sayHiStatus().then((resData) => {
        this.actStatus = resData.status
        if (resData.expired) {
          this.$client.showToast(resData.message)
          return
        }

        if (this.env.isApp) {
          const userInfo = this.$client.getUserBaseInfo()
          const appInfo = this.$client.getAppInfo()
          if (userInfo.token && appInfo.deviceId && appInfo.appPackageName) {
            const utJson = JSON.stringify({ uid: userInfo.uid, token: userInfo.token })
            let ut = encryptCode(utJson, SecretKey.uploadCodePub)
            const daJson = JSON.stringify({ deviceId: appInfo.deviceId, appPackageName: appInfo.appPackageName })
            let da = encryptCode(daJson, SecretKey.uploadCodePub)
            ut = encodeURIComponent(ut)
            da = encodeURIComponent(da)
            const link = `${window.location.origin}/#/say-hi?ut=${ut}&da=${da}`
            this.appAction('open_web_outside', `?url=${link}`)
          }
          return
        }

        // vant 组件
        this.$refs.vanUploader && this.$refs.vanUploader.chooseFile()
      })
    },
    afterRead(e) {
      if (e.file) {
        if (!this.isVideoFile(e.file)) {
          this.$client.showToast(this.$t('lang.SayHi.k013'))
          return
        }
        this.getVideoDuration(e.file).then((duration) => {
          duration = Math.floor(duration)
          if (duration < 20 || duration > 50) {
            this.$client.showToast(this.$t('lang.SayHi.k003'))
            return false
          }
          uploadObj.currentFile = e.file
          this.uploadFileInChunks(e.file)
        })
      }
    },
    handleShowVideo(url) {
      if (url) {
        this.currentVideo = url
        this.showVideo = true
      }
    },
    handleClosePlay() {
      this.currentVideo = ''
      this.showVideo = false
    },
    initNativeScroll(event) {
      const clientH = document.documentElement.clientHeight
      const scrollH = document.body.scrollHeight
      const scrollT = event.target.scrollTop
      const distance = 300

      // 触底
      if (scrollT + clientH >= scrollH - distance) {
        if (!this.nativeScroll.lockLoad) {
          this.nativeScroll.lockLoad = true
          setTimeout(() => {
            this.loadVideos()
          }, 100)
        }
      }
    },
    newNativeScroll() {
      document.body.addEventListener('scroll', this.initNativeScroll)
      this.nativeScroll = {
        lockLoad: false,
        finishPullUp: function () {
          this.lockLoad = false
        },
        refresh: function () {},
      }
    },
    offNativeScroll() {
      document.body.removeEventListener('scroll', this.initNativeScroll)
    },
    closeShowRewardDia() {
      this.showRewardDia = false
      this.rewardNumber = 0
    },
    // 奖励弹窗背景图加载失败时隐藏 img，避免 iOS 显示蓝色问号占位
    onRewardBgError(e) {
      const el = e && e.target
      if (el && el.style) {
        el.style.display = 'none'
      }
    },
  },
  created() {
    this.getBeforeUploadInfo()
    this.getActStatus()
    this.loadVideos()
  },
  mounted() {
    this.newNativeScroll()
  },
  beforeDestroy() {
    if (uploadObj.key && uploadObj.uploadId) {
      this.cancelUpload()
    }
    awsClient = null
    this.offNativeScroll()
  },
}
</script>
<style lang="scss" scoped>
.act-sayhi-root {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #fbeac6 0%, #ffffff 100%);

  .custom-nav-block {
    background-image: linear-gradient(180deg, #fbeac6 0%, #ffffff 100%);
    background-repeat: no-repeat;
    background-size: 100% 100vh;
  }

  .sayhi-content {
    padding: 16px 0 36px;
    .sayhi-head {
      width: 100%;
      line-height: 26px;
      font-family: 'Roboto-Regular';
      font-size: 22px;
      font-weight: bold;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sayhi-date {
      margin-top: 12px;
      width: 100%;
      line-height: 20px;
      font-family: 'Roboto-Regular';
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      text-align: center;
    }
    .sayhi-bg {
      width: 246px;
      height: 120px;
      margin: 10px auto 0;
      position: relative;
      .sayhi-bg-icon1,
      .sayhi-bg-icon2 {
        width: 20px;
        height: 20px;
        position: absolute;
      }
      .sayhi-bg-icon1 {
        left: 0;
        top: 25px;
      }
      .sayhi-bg-icon2 {
        right: 0;
        top: 45px;
      }
      .sayhi-bg-main {
        display: block;
        width: 120px;
        height: 120px;
        margin: 0 auto;
      }
      .sayhi-bg-tips {
        width: 24px;
        height: 17px;
        position: absolute;
        top: 33px;
        right: 55px;
      }
      .sayhi-claimed {
        position: absolute;
        top: 0;
        right: 24px;
        min-width: 80px;
        height: 34px;
        background: #ffe260;
        padding: 0 10px;
        box-shadow: 0px 1px 2px 0px rgba(202, 101, 29, 0.5);
        border-radius: 17px;

        font-family: 'Roboto-Regular';
        font-size: 15px;
        color: #c0711f;
        line-height: 34px;
        text-align: center;
      }
    }
    .sayhi-tips {
      width: 355px;
      height: 44px;
      margin: 19px auto 0;
      font-family: 'Roboto-Regular';
      font-weight: 400;
      font-size: 15px;
      color: #666666;
      line-height: 22px;
    }

    .sayhi-upload {
      width: 355px;
      margin: 16px auto 0;
      padding: 24px 12px;
      border-radius: 12px;
      border: 1px solid #f7e5cf;
      display: flex;
      gap: 10px;
      align-items: center;

      .upload-video {
        width: 100px;
        height: 150px;
        border-radius: 4px;
        background-color: #ededed;
        overflow: hidden;
        position: relative;
        img {
          float: left;
          width: 100%;
          height: 100%;
          border: 0;
          outline: none;
        }
        &::after {
          content: '';
          background: url(./images/play-icon.webp) center center / 100% 100% no-repeat;
          width: 30px;
          height: 30px;
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 99;
          margin-left: -15px;
          margin-top: -15px;
        }
      }

      .upload-btns {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
          font-family: 'Roboto-Regular';
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          line-height: 18px;
        }
        button {
          outline: 0;
          width: 163px;
          height: 54px;
          margin-top: 16px;
          background: linear-gradient(270deg, #cacaca 0%, #dddddd 100%);
          border-radius: 27px;
          font-family: 'Roboto-Regular';
          font-size: 17px;
          color: #999999;

          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }
        }
        button.upload-yellow {
          background: linear-gradient(270deg, #fed446 0%, #ffe37c 100%);
          color: #333333;
        }
      }
    }

    .sayhi-upload.no-video-block {
      display: flex;
      flex-direction: column;
      gap: 0;
      .reject-txt {
        width: 100%;
        line-height: 20px;
        font-family: 'Roboto-Regular';
        font-weight: 400;
        font-size: 15px;
        color: #ff0000;
        text-align: center;
      }
      .upload-btns {
        margin-bottom: 24px;
        button {
          width: 259px;
        }
      }
      .upload-tips-txt {
        width: 100%;
        line-height: 15px;
        font-family: 'Roboto-Regular';
        font-size: 13px;
        color: #666666;
        line-height: 15px;
        margin-bottom: 9px;
        display: flex;
        &:last-child {
          margin-bottom: 0;
        }
        span {
          margin-left: 4px;
        }
      }
    }

    .videos-title {
      width: 355px;
      height: 20px;
      margin: 30px auto 0;
      font-family: 'Roboto-Regular';
      font-weight: normal;
      font-size: 17px;
      color: #333333;
      line-height: 20px;
    }

    .videos-block {
      margin-top: 16px;
      overflow: hidden;
      padding: 0 10px;
      .video-item {
        float: left;
        width: calc(50% - 6px);
        height: 258px;
        margin-bottom: 10px;
        border-radius: 4px;
        background-color: rgb(237, 237, 237);
        position: relative;
        overflow: hidden;

        img {
          float: left;
          width: 100%;
          height: 100%;
        }

        &:nth-child(2n) {
          margin-left: 12px;
        }

        &::after {
          content: '';
          background: url(./images/play-icon.webp) center center / 100% 100% no-repeat;
          width: 40px;
          height: 40px;
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 99;
          margin-left: -20px;
          margin-top: -20px;
        }
      }
    }
  }

  .is-loading {
    padding-top: 10px;
    text-align: center;
  }

  .no-more {
    padding-top: 10px;
    text-align: center;
    color: #b2b2b2;
    font-size: 16px;
  }

  .upload-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .cancel-upload {
      box-sizing: content-box;
      width: 30px;
      height: 30px;
      margin-top: 30px;
      border-radius: 50%;
      font-size: 28px;
      text-align: center;
      line-height: 30px;
      background-color: #fafafa;
      border: 10px solid transparent;
    }

    .will-play {
      width: 75%;
      min-height: 30%;
      max-height: 70%;
      background-color: rgb(0, 0, 0);
      display: flex;
      position: relative;

      .cancel-play {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 99;
        box-sizing: content-box;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        font-size: 28px;
        color: #ffffff;
        text-align: center;
        line-height: 20px;
        background: rgba(0, 0, 0, 0.5);
        border: 10px solid transparent;
      }
    }
  }

  ::v-deep .van-popup {
    background-color: transparent;
  }

  .van-popup-box {
    width: 350px;
    padding: 0px 20px 40px;
    overflow: hidden;
  }

  .reward-dia {
    width: 300px;
    height: 300px;
    margin: 0 auto;
    position: relative;
    font-family: 'Inter-Regular';
    overflow: hidden;
  }

  .bulibuli {
    display: block;
    width: 300px;
    height: 300px;
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    margin-left: -150px;
    margin-top: -150px;
  }
  .number {
    position: absolute;
    z-index: 20;
    top: 55%;
    left: 50%;
    transform: translate(-50%, 0);
    display: block;
    margin-top: 30px;
    font-family: 'Inter-Bold';
    font-size: 45px;
    color: #ffac00;
    text-stroke: 1px #ffffff;
    -webkit-text-stroke: 1px #ffffff;
    i {
      font-size: 30px;
      margin-right: 4px;
    }
  }
  .reward-dia-btn {
    width: 100%;
    color: #ffffff;
    font-size: 16px;
    font-family: 'Inter-Regular';
    text-align: center;
    > span {
      padding: 8px 30px;
      margin: 0 auto;
      line-height: 40px;
      border-radius: 20px;
      background: #a338fc;
    }
  }
}

.can-claim {
  animation: shake-bottom 1.5s ease-in-out infinite;
}

@keyframes shake-bottom {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(12deg);
  }
  20% {
    transform: rotate(-12deg);
  }
  30% {
    transform: rotate(-12deg);
  }
  40% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
<style>
.sayhi-head-beans {
  width: 27px;
  height: 27px;
}
</style>
